import { render, staticRenderFns } from "./FilteredAdvertisementsData.vue?vue&type=template&id=6bca54b3&"
import script from "./FilteredAdvertisementsData.vue?vue&type=script&lang=js&"
export * from "./FilteredAdvertisementsData.vue?vue&type=script&lang=js&"
import style0 from "./FilteredAdvertisementsData.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports